module.exports = __webpack_public_path__ + "static/media/loading.8894b7d3.gif";